<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='/archive-purchases'>{{translations('navbar.purchase_management')}}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-purchases'>{{translations('purchase.archive_order')}}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{translations('purchase.order_details')}}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <div class='form-inline mb-4'>
            <div class='form-group mr-3'>
              <button class='btn btn-primary' :disabled="(Number(purchaseInfo.purchase_status) === 2)" data-toggle="modal" data-target="#StockingModal">{{translations('purchase.arrival_processing')}}</button>
            </div>
            <div class='form-group ml-3'>
              <button class='btn btn-primary' :disabled="purchaseInfo.is_paid" data-toggle="modal" data-target="#PaymentModal">{{translations('purchase.withdrawal_processing')}}</button>
            </div>
          </div>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{translations('purchase.order_date')}}</th>
                <td>
                  <button
                    ref='info01'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info01'
                    data-placement='right'
                  >{{ purchaseInfo.purchase_at ? $invoiceTools.formatDateAt(purchaseInfo.purchase_at) : '-----------' }}</button>
                  <div id='popover-info01' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('purchase.order_date')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='date' v-model="tempInfo.purchase_at" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('purchase_at', tempInfo.purchase_at, 'info01')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ this.translations('purchase.purchase_status') }}</th>
                <td>
                  <span class="badge" :class="getStatusClass(purchaseInfo.purchase_status)">
                    {{ getStatusLabel(purchaseInfo.purchase_status) }}
                  </span>
                </td>
              </tr>
              <tr>
                <th>{{translations('purchase.name')}}</th>
                <td>
                  <button
                    ref='info02'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info02'
                    data-placement='right'
                  >{{ purchaseInfo.name ? purchaseInfo.name : '-----------' }}</button>
                  <div id='popover-info02' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('purchase.name')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempInfo.name" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('name', tempInfo.name, 'info02')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('purchase.client_order_number')}}</th>
                <td>{{purchaseInfo.purchase_number}}</td>
              </tr>
              <tr>
                <th>{{translations('purchase.payment_destination')}}</th>
                <td>{{purchaseInfo.kaishu_partner_name}}</td>
              </tr>
              <tr>
                <th>{{translations('purchase.warehouse')}}</th>
                <td v-if="Number(purchaseInfo.purchase_status) === 1">
                  <button
                    ref='info05'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info05'
                    data-placement='right'
                  >{{ purchaseInfo.kaishu_warehouse_name ? purchaseInfo.kaishu_warehouse_name : '-----------' }}</button>
                  <div id='popover-info05' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('purchase.warehouse')}}
                    </div>
                    <div class='popover-body popover-content'>
                     <select class='custom-select' v-model="tempInfo.kaishu_warehouse_id">
                        <option selected value="-">-</option>
                        <option v-for="(warehouse, i) in warehouses" :key="i" :value='warehouse.id'>{{ warehouse.name }}</option>
                      </select>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('kaishu_warehouse_id', tempInfo.kaishu_warehouse_id, 'info05')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
                <td v-else>{{ purchaseInfo.kaishu_warehouse_name }}</td>
              </tr>
              <tr>
                <th>{{translations('purchase.stock_date')}}</th>
                <td>
                  <button
                    ref='info08'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info08'
                    data-placement='right'
                  >{{ purchaseInfo.arrival_scheduled_at ? $invoiceTools.formatDateAt(purchaseInfo.arrival_scheduled_at) : '-----------' }}</button>
                  <div id='popover-info08' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('purchase.stock_date')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='date' v-model="tempInfo.arrival_scheduled_at" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('arrival_scheduled_at', tempInfo.arrival_scheduled_at, 'info08')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('purchase.date_payment')}}</th>
                <td>{{ $invoiceTools.formatDateAt(purchaseInfo.paid_at) }}</td>
              </tr>
              <tr>
                <th>{{translations('purchase.remarks')}}</th>
                <td>
                  <button
                    ref='info07'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info07'
                    data-placement='right'
                  >{{ purchaseInfo.memo ? purchaseInfo.memo : '-----------' }}</button>
                  <div id='popover-info07' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('purchase.remarks')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempInfo.memo" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('memo', tempInfo.memo, 'info07')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('common.last_updated_by')}}</th>
                <td>{{purchaseInfo.updated_by}}</td>
              </tr>
              <tr>
                <th>{{translations('common.last_update_time')}}</th>
                <td>{{purchaseInfo.updated_at}}</td>
              </tr>
            </tbody>
          </table>
          <hr>
          <h5 class="mb-3">Files</h5>
          <div class="card" :class="(invoiceFile == null) ? 'hidden' : ''">
            <ul class="list-group list-group-flush">
              <li class="list-group-item list-group-item-info d-flex justify-content-between"><a @click="openInvoiceFile">{{translations('purchase.invoice')}}<i class="fas fa-external-link-alt"></i></a><button type="button" class="btn btn-link p-0 mr-1" @click="invoiceFile = null"><i class="far fa-times-circle"></i></button></li>
            </ul>
          </div>
          <div class="card" :class="(invoiceFile == null) ? '' : 'hidden'">
            <ul class="list-group list-group-flush">
              <li class="list-group-item"><button class="btn btn-link p-0" type="button" data-toggle="modal" data-target="#InvoiceFileModal">{{translations('purchase.invoice')}}<i class="fas fa-paperclip"></i></button></li>
            </ul>
          </div>
          <hr>
          <div class='form-inline'>
            <div class='form-group'>
              <a class='btn btn-link btn-sm text-danger' @click.self="deletePurchase()" data-href='#'>{{translations('common.delete')}}</a>
            </div>
          </div>
        </div>
        <div class='right-container'>
          <div class="form-inline justify-content-end"><!-- VAT -->
            <div v-if="taxIncluded" class="text-danger">{{translations('common.tax_included')}}</div><!-- TAXSTATUS -->
            <div v-else>{{translations('common.tax_excluded')}}</div>
          </div>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-1100'>
              <thead>
                <tr>
                  <th></th>
                  <th>{{translations('purchase.jan_code')}}</th>
                  <th>{{translations('purchase.model')}}</th>
                  <th>{{translations('purchase.tax_classification')}}</th><!-- TAXSTATUS -->
                  <th style="min-width:80px;">{{translations('purchase.count')}}</th>
                  <th>{{translations('purchase.unit_price')}}</th>
                  <th></th>
                  <th>{{translations('purchase.summary')}}</th>
                  <th>{{translations('purchase.unit_price_total')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for="(detail, i) in purchaseDetails">
                  <tr :key="i">
                    <td v-if="detail.remain_quantity == 0 || detail.remain_quantity < detail.quantity ">
                    </td>
                    <td v-else>
                      <button @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                    </td>
                    <td>{{ detail.jan_code }}</td>
                    <td>{{ detail.model }}</td>
                    <td v-if="Number(purchaseInfo.purchase_status) === 1">
                      <select
                       :disabled="false"
                        v-model="detail.taxclass_id"
                        v-validate="'required'"
                        data-vv-name="taxclass_id"
                        data-vv-as="税区分"
                        class="custom-select width-100-px"
                        required
                        @change="onChangePrice(detail)"
                      >
                        <option value="1">課税対象</option>
                        <option value="2">対象外</option>
                      </select>
                    </td>
                    <td v-else>{{ Number(detail.taxclass_id) === 1 ? '課税対象' : '対象外' }}</td>

                    <td class="right" style="padding-right:40px;">{{ Number(detail.quantity).toLocaleString() }}</td>

                    <template v-if="Number(purchaseInfo.purchase_status) === 1">
                      <td class="right">
                        <div class="number-container">
                          <input type="text" :placeholder="detail.row_price" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price" @input="onChangePrice(detail, $event)"/>
                          <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price && detail.unit_price.toLocaleString() }}</span>
                        </div>
                      </td>
                      <td v-if="Number(detail.taxclass_id) === 1">({{ $util.getIncludeTax(detail.unit_price, detail.tax_rate).toLocaleString()}})</td>
                      <td v-else></td>
                    </template>
                    <template v-else>
                      <td class="right" colspan="2">{{ toTaxFormat(detail, 'unit_price') }}</td>
                    </template>

                    <td>{{ detail.remarks }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_unit_price') }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td>
                    <button
                      class='btn-change plus'
                      type='button'
                      data-toggle='modal'
                      data-target='#PurchaseDetailsModal'
                      :disabled="purchaseInfo.purchase_status != 1"
                    >
                      <i></i>
                    </button>
                  </td>
                  <td></td>
                  <td></td><!-- TAXSTATUS -->
                  <td></td>
                  <th></th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class='font-weight-bold right'>{{ Number(grandTotalUnitPrice).toLocaleString() }} ({{ Number(grandTotalUnitPriceIncTax).toLocaleString() }})</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class='form-inline'>
            <div class='form-group'>
              <button class='btn btn-sm btn-primary' @click="updatePurchase()">{{translations('common.update')}}</button>
            </div>
            <div class="form-group">
              <a v-on:click="openDeliverySlip()" class="btn btn-link btn-sm decoration-underline" href="#" >{{translations('purchase.purchase_order_output')}}<i class="fas fa-external-link-alt"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PurchaseDetailsModal :details="purchaseDetails" :vat="{taxIncluded:taxIncluded, vatRate:vatRate}"/><!-- VAT -->
    <StockingModal :purchase-id="purchaseId" :details="purchaseDetails"/>
    <InvoiceFileModal/>
    <PaymentModal :purchase-id="purchaseId" :amount="purchaseInfo.total_amount" :paid="purchaseInfo.total_paid" :partner="purchaseInfo.kaishu_partner_name"/>
    <vue-element-loading :active='isLoading' :is-full-screen='true'/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import PurchaseDetailsModal from '@/components/purchase/PurchaseDetailsModal'
import StockingModal from '@/components/purchase/StockingModal'
import InvoiceFileModal from '@/components/purchase/InvoiceFileModal'
import PaymentModal from '@/components/purchase/PaymentModal'
import { OrderStatus } from '@/constants'
import { mapState } from 'vuex'

export default {
  name: 'SinglePurchase',
  props: {},
  components: {
    VueElementLoading,
    PurchaseDetailsModal,
    StockingModal,
    InvoiceFileModal,
    PaymentModal
  },

  data () {
    return {
      vatRate: 0, // VAT
      taxIncluded: false, // VAT
      purchaseId: 0,
      purchaseInfo: {},
      purchaseDetails: [],
      tempInfo: {},
      grandTotalUnitPrice: 0,
      grandTotalUnitPriceIncTax: 0,
      isLoading: true,
      deliveryFile: null,
      invoiceFile: null
    }
  },

  computed: {
    ...mapState(['currentLanguage']),
    warehouses () {
      return this.$store.getters['Master/getMywarehouses']
    },
    confirmationDeletePurchaseMessage () {
      return this.translations('purchase.delete_purchase')
    },
    confirmationUpdatePurchaseMessage () {
      return this.translations('purchase.update_purchase')
    },
    confirmButtonText () {
      return this.translations('common.yes')
    },
    cancelButtonText () {
      return this.translations('common.no')
    }
  },

  watch: {
    purchaseDetails: {
      handler (v) {
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = this.prepareDetails(d)
          }
        })
        this.calcGrandTotals()
      },
      deep: true
    }
  },

  created () {
    if (!this.$route.query.purchase_id) {
      this.$router.replace('archive-purchases')
      return
    }

    this.purchaseId = Number(this.$route.query.purchase_id)
    this.$store.dispatch('Master/checkMywarehouses')

    Promise.all([
      this.getPurchase()
    ]).then(() => {
      this.calcGrandTotals()
      this.popoverButtons()
      this.isLoading = false
    }).catch(error => {
      this.$toastr.error(error, 'エラー')
    })
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getPurchase () {
      return this.$http.post(this.$api_url.purchase_detail, { purchase_id: this.purchaseId }).then(response => {
        const result = response.data
        if (result.status === true) {
          this.purchaseInfo = result.information
          this.purchaseDetails = result.details
          this.taxIncluded = result.information.tax_included
          this.vatRate = result.information.tax_rate
          this.invoiceFile = result.information.invoice_file

          this.tempInfo = JSON.parse(JSON.stringify(this.purchaseInfo))
        } else {
          return Promise.reject(new Error(result.message))
        }
      }).catch(function (error) {
        console.log('SinglePurchase:getPurchase:catch(error): ', error)
        return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
      }).finally(() => {
        this.isLoading = false
      })
    },

    async openDeliverySlip () {
      if (!this.deliveryFile) {
        try {
          const response = await this.$http.post(this.$api_url.purchase_pdf, { purchase_id: this.purchaseId })
          const result = response.data
          if (result.status === true && result.pdf) {
            this.deliveryFile = result.pdf
          } else {
            this.$toastr.error(result.message, 'エラー')
          }
        } catch (error) {
          console.log('SinglePurchase:openDeliverySlip:catch(error): ', error)
          this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        }
      }

      if (this.deliveryFile) {
        const arrBuff = this.__b64ToArrayBuffer(this.deliveryFile.replace('data:application/pdf;base64,', ''))
        const deliveryFile = new Blob([arrBuff], { type: 'application/pdf' })
        const deliveryFileURL = URL.createObjectURL(deliveryFile)
        window.open(deliveryFileURL)
      }
    },

    openInvoiceFile () {
      if (this.invoiceFile != null) {
        let arrBuff = this.__b64ToArrayBuffer(this.invoiceFile.replace('data:application/pdf;base64,', ''))
        const pdfFile = new Blob([arrBuff], { type: 'application/pdf' })
        const pdfFileURL = URL.createObjectURL(pdfFile)
        window.open(pdfFileURL)
      }
    },

    __b64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      let len = binaryString.length
      let bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },

    popoverButtons () {
      window.$('button[data-toggle="popover-x"]').each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    /**
     * @param field : orders information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref) {
      let val = ''
      const rg = /^\s+$/
      if (
        value === '-' ||
        value === '' ||
        rg.test(value) === true ||
        typeof value === 'undefined'
      ) {
        this.$refs[ref].innerText = '-----------'
        val = ''
      } else if (field === 'purchase_at') {
        this.$refs[ref].innerText = this.$invoiceTools.formatDateAt(value)
        val = value
      } else if (field === 'arrival_scheduled_at') {
        this.$refs[ref].innerText = this.$invoiceTools.formatDateAt(value)
        val = value
      } else if (field === 'kaishu_warehouse_id') {
        const warehouse = this.warehouses.find(warehouse => warehouse.id === value)
        if (warehouse) {
          val = Number(warehouse.id)
          this.tempInfo.kaishu_warehouse_id = val
          this.$refs[ref].innerText = warehouse.name
        } else {
          this.tempInfo.kaishu_warehouse_id = 0
          this.$refs[ref].innerText = '-----------'
        }
      } else {
        this.$refs[ref].innerText = value
        val = value
      }
      this.purchaseInfo[field] = val
      window.$('#popover-' + ref).popoverX('hide')
    },

    deleteDetail (i) {
      this.purchaseDetails.splice(i, 1)
    },

    toTaxFormat (data, key) {
      const price = data[key] || 0

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        if (key === 'unit_price') {
          data.unit_price = price
          data.unit_price_inctax = price
        }
        return Number(price).toLocaleString()
      }

      const taxIncluded = data.tax_included || this.taxIncluded
      const taxRate = Number(data.tax_rate || this.taxRate)
      const inctax = this.$util.getIncludeTax(price, taxRate)
      if (key === 'unit_price') {
        data.unit_price = price
        data.unit_price_inctax = inctax
      }
      if (!taxIncluded) { // 税込以外
        return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
      } else {
        return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
      }
    },

    prepareDetails (data) {
      data.total_unit_price = data.quantity * data.unit_price

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.unit_price_inctax = Number(data.unit_price)
        data.total_unit_price_inctax = data.total_unit_price
      } else {
        data.unit_price_inctax = this.$util.getIncludeTax(data.unit_price, Number(data.tax_rate || this.taxRate))
        data.total_unit_price_inctax = this.$util.getIncludeTax(data.total_unit_price, data.tax_rate)
      }

      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalUnitPriceIncTax = 0

      this.purchaseDetails.forEach(v => {
        this.grandTotalUnitPrice += Number(v.total_unit_price)
      })

      this.grandTotalUnitPriceIncTax = this.$util.getIncludeTax(this.grandTotalUnitPrice, this.taxRate)
    },

    updatePurchase () {
      if (this.purchaseDetails.length === 0) {
        this.$toastr.warning('詳細行を入力してください。')
        return
      }

      this.$dialog.confirm(this.confirmationUpdatePurchaseMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      }).then(async () => {
        try {
          if (this.invoiceFile != null) {
            this.purchaseInfo.invoice_file = this.invoiceFile
          } else {
            this.purchaseInfo.invoice_file = null
          }

          this.isLoading = true

          this.purchaseInfo.total_amount = this.grandTotalUnitPriceIncTax

          const paramUpdate = {
            purchase_id: this.purchaseId,
            information: this.purchaseInfo,
            details: this.purchaseDetails
          }
          const response = await this.$http.post(this.$api_url.purchase_update, paramUpdate)
          const result = response.data
          console.log('SinglePurchase:updatePurchase: ', result)
          if (result.status === true) {
            this.$toastr.success('発注が更新しました。', 'Success')
          } else {
            this.$toastr.error(result.message, 'エラー')
          }
          this.isLoading = false
        } catch (error) {
          console.log('SinglePurchase:updatePurchase:catch(error): ', error)
          this.$toastr.error('発注更新がエラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        }
      })
    },

    deletePurchase () {
      this.$dialog.confirm(this.confirmationDeletePurchaseMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      })
        .then(async () => {
          this.isLoading = true
          try {
            let del = await this.$http.post(this.$api_url.purchase_delete, { purchase_id: this.purchaseId })
            let $data = this.$invoiceTools.prepareResult(del.data, '', 'SinglePurchase:deletePurchase')
            if ($data.success === true) {
              this.$toastr.success('発注を削除しました', 'Success')
              this.$router.replace('archive-purchases')
              setTimeout(() => { this.isLoading = false }, 1000)
            } else {
              this.$toastr.error($data.data, 'エラー')
            }
            this.isLoading = false
          } catch (error) {
            this.isLoading = false
            console.log('SinglePurchase:deleOrders:catch(error): ', error)
            this.$toastr.error('発注削除にエラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
          }
        }).catch(() => { console.log('Clicked `Cancel`') })
    },

    onChangePrice (detail, e) {
      if (e) {
        e.target.nextElementSibling.innerText = Number(e.target.value).toLocaleString()
      }
      this.purchaseDetails.forEach((detail, i) => {
        this.purchaseDetails[i] = this.prepareDetails(detail)
      })
      this.calcGrandTotals()
    },

    getStatusClass (status) {
      if (Number(status) === OrderStatus.NOT_SHIPPED) {
        return 'badge-light'
      } else if (Number(status) === OrderStatus.SHIPPED) {
        return 'badge-success'
      } else if (Number(status) === OrderStatus.PARTIAL_SHIPMENT) {
        return 'badge-warning'
      }
      return 'badge-warning'
    },

    getStatusLabel (status) {
      if (Number(status) === OrderStatus.NOT_SHIPPED) {
        return this.translations('purchase.not_in_stock')
      } else if (Number(status) === OrderStatus.SHIPPED) {
        return this.translations('purchase.already_in_stock')
      } else if (Number(status) === OrderStatus.PARTIAL_SHIPMENT) {
        return this.translations('purchase.partially_in_stock')
      }
      return this.translations('purchase.not_applicable')
    }
  }
}
</script>
